import React, { useContext, useEffect, useState } from 'react'
import artistBanner from '../../assets/artistBanner.png'
import { ARTIST_LISTING_DESCRIPTION, ARTIST_LISTING_TITLE } from '../../utils/constants'
import { AppContext } from '../../context/app'
import useAxios from 'axios-hooks'
import { ARTIST_LISTING } from '../../utils/apiUrls'
import ArtistCard from '../../components/artistCard'
import { shuffle } from 'lodash'
import { withTheme } from 'theming'
import { useTranslation } from 'react-i18next'
import SearchIcon from '../../components/template/imgComponents/searchIcon'

const ArtistListing = ({ theme }) => {
  const { t } = useTranslation()
  const { setLoader, isCustomTemplate } = useContext(AppContext)
  const [dataList, setDataList] = useState([])
  const [filteredDataList, setFilteredDataList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [{ data: artistList, loading: artistListLoading }] = useAxios({
    url: ARTIST_LISTING,
    method: 'get',
    params: {
      page_size: 2000,
      page: 1,
    },
  })

  useEffect(() => {
    setDataList([])
    // window.addEventListener('scroll', infiniteScroll)
    // return () => {
    //   window.removeEventListener('scroll', infiniteScroll)
    // }
  }, [])

  useEffect(() => {
    if (artistList && artistList.success) {
      setDataList(shuffle(artistList.data))
      setFilteredDataList(shuffle(artistList.data))
    }
  }, [artistList])

  useEffect(() => {
    setLoader(artistListLoading)
  }, [artistListLoading])

  // const infiniteScroll = () => {
  //   console.log('heree')
  //   // End of the document reached?
  //   if (
  //     window.innerHeight + document.documentElement.scrollTop >
  //     0.8 * document.documentElement.offsetHeight
  //   ) {
  //     if (!apiHit && totalRecords > currentPage * PAGE_SIZE) {
  //       apiHit = true
  //       currentPage += 1
  //       hitAPI(currentPage)
  //     }
  //   }
  // }

  const handleSearch = (event) => {
    if (event.key === 'Enter' || event.type === 'click') {
      const term = searchTerm.trim().toLowerCase()
      if (!term) {
        setFilteredDataList(dataList)
        return
      }

      const filtered = dataList.filter((artist) => artist.name?.toLowerCase().includes(term))
      setFilteredDataList(filtered)
    }
  }

  return (
    <div>
      <div className="w-full relative">
        <img
          style={{ aspectRatio: '8.0672' }}
          src={artistBanner}
          className="w-full"
          alt="Artist Banner"
        />
        <div
          style={{ color: isCustomTemplate ? theme.c7 : '#fff' }}
          className=" absolute top-1.5 left-3 lg:top-10 lg:left-36"
        >
          <p className="text-xs md:text-4xl font-bold">{ARTIST_LISTING_TITLE}</p>
          <p className="text-xs md:text-base">{ARTIST_LISTING_DESCRIPTION}</p>
        </div>
      </div>
      <div className=" w-full px-10 md:px-16 lg:px-20 mt-5 xl:mt-10 flex justify-center z-40 relative">
        <div
          style={{
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            background: '#0f172195',
            color: '#00ffff',
          }}
          className="w-full px-6 flex justify-between items-center py-[9px] xl:relative"
        >
          <p className="w-3/4 line-clamp-1 text-sm xl:text-[22px] font-bold  ">
            <div className="w-1/2 relative flex justify-center items-center">
              <input
                placeholder={t('search')}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ background: 'transparent', border: '1px solid #00ffff' }}
                className="text-sm rounded-full  w-full text-white px-5 py-1 focus:outline-none z-0"
                onKeyPress={(e) => handleSearch(e)}
              />
              <SearchIcon
                color="#00ffff"
                imgStyle={{
                  width: '25px',
                  height: '25px',
                  right: '5px',
                }}
                imgClass={'absolute z-20 '}
                imgClick={handleSearch}
              />
            </div>
          </p>
          <div className=" xl:flex justify-between items-center text-sm">
            {/* <p className="mb-0">
              {`'${totalRecords}'`} {t('results')}
            </p> */}
            <p
              className="mb-0 underline cursor-pointer"
              onClick={() => {
                setSearchTerm('')
                setFilteredDataList(dataList)
              }}
            >
              {t('clear_all')}
            </p>
          </div>
        </div>
      </div>

      {filteredDataList && filteredDataList.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 px-4 py-5 md:px-16 md:py-10 lg:px-24 xl:py-6">
          {filteredDataList.map((item, index) => (
            <ArtistCard item={item} key={index} />
          ))}
        </div>
      ) : (
        searchTerm && (
          <p className="text-center text-lg md:text-3xl text-white mt-4">
            {t('no_artist_found')} &quot;{searchTerm}&quot;
          </p>
        )
      )}
    </div>
  )
}

export default withTheme(ArtistListing)
